// ═══════════════════════════════════════════════════════════════
// PACE — Module Layout with sub-navigation
// ═══════════════════════════════════════════════════════════════

import { Outlet, useLocation } from 'react-router-dom';
import {
  IconLayoutDashboard, IconAntenna, IconPhone, IconFileText, IconUsers,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';
import PageHeader from '../../components/ui/PageHeader';
import ModuleNav from '../../components/layout/ModuleNav';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/pace', icon: IconLayoutDashboard, exact: true },
  { label: 'My PACE', path: '/pace/my-pace', icon: IconAntenna },
  { label: 'Directory', path: '/pace/directory', icon: IconUsers },
  { label: 'Call-Downs', path: '/pace/calldowns', icon: IconPhone },
  { label: 'Plans', path: '/pace/plans', icon: IconFileText },
];

export default function PaceLayout() {
  const { pathname } = useLocation();
  const visibleItems = useFilteredNav('pace', NAV_ITEMS);

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      <PageHeader
        breadcrumbs={[
          { label: 'Prepare', route: '/' },
          { label: 'PACE' },
        ]}
        title="PACE"
        subtitle="Primary, Alternate, Contingency & Emergency communications planning"
      />
      <ModuleNav items={visibleItems} accentColor={brand.blurple} />
      <Outlet />
    </div>
  );
}
